import { useNavigate } from "react-router-dom"
import { CloseIcon, MyListIcon, SearchIcon } from "./Icons"
import {
  ActionsModalWrapper,
  ActionsModalContent,
  CloseButton,
  ActionsBox,
  ActionItem,
  ActionItemTitle,
  WaterTrackerAction,
  WaterTrackerTitle,
} from "./styled"
import PATHS from "router/paths"
import AIScanAction from "./AIScanAction"
import { useAppSelector } from "app/hooks"
import BarcodeScanAction from "./BarcodeScanAction"
import WaterIcon from "components/Icons/WaterIcon"

const ActionsModal = ({
  onClose,
  hasAIScanEntitlement,
  hasBarcodeScanningEntitlement,
}: {
  onClose: () => void
  hasAIScanEntitlement: boolean
  hasBarcodeScanningEntitlement: boolean
}) => {
  const navigate = useNavigate()

  const getUserPlanLoading = useAppSelector(
    (state) => state.payment.getUserPlanLoading,
  )

  return (
    <ActionsModalWrapper>
      <ActionsModalContent>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>

        <ActionsBox>
          <ActionItem
            onClick={() => {
              navigate(PATHS.app.food.search)
            }}
          >
            <SearchIcon />
            <ActionItemTitle>Search/Recent</ActionItemTitle>
          </ActionItem>

          <ActionItem
            onClick={() => {
              navigate(PATHS.app.myFoods.root)
            }}
          >
            <MyListIcon />
            <ActionItemTitle>My List</ActionItemTitle>
          </ActionItem>

          <BarcodeScanAction
            hasBarcodeScanningEntitlement={hasBarcodeScanningEntitlement}
            getUserPlanLoading={getUserPlanLoading}
          />

          <AIScanAction
            hasAIScanEntitlement={hasAIScanEntitlement}
            getUserPlanLoading={getUserPlanLoading}
          />

          <WaterTrackerAction
            onClick={() => {
              onClose()
              navigate(PATHS.app.water.root)
            }}
          >
            <WaterIcon />

            <WaterTrackerTitle>Water Tracker</WaterTrackerTitle>
          </WaterTrackerAction>
        </ActionsBox>
      </ActionsModalContent>
    </ActionsModalWrapper>
  )
}

export default ActionsModal
